module.exports = __webpack_public_path__ + "static/twitter-icon-d44c620212500dbdbb8d91472e659f1b.png";